/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetUnproxiedMcpServerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetUnproxiedMcpServerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetUnproxiedMcpServerSecurity = {
  option1?: GetUnproxiedMcpServerSecurityOption1 | undefined;
  option2?: GetUnproxiedMcpServerSecurityOption2 | undefined;
};

export type GetUnproxiedMcpServerRequest = {
  /**
   * The ID of the unproxied MCP server. Mutually exclusive with slug.
   */
  id?: string | undefined;
  /**
   * The slug of the unproxied MCP server. Mutually exclusive with id.
   */
  slug?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetUnproxiedMcpServerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetUnproxiedMcpServerSecurityOption1$outboundSchema: z.ZodMiniType<
  GetUnproxiedMcpServerSecurityOption1$Outbound,
  GetUnproxiedMcpServerSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getUnproxiedMcpServerSecurityOption1ToJSON(
  getUnproxiedMcpServerSecurityOption1: GetUnproxiedMcpServerSecurityOption1,
): string {
  return JSON.stringify(
    GetUnproxiedMcpServerSecurityOption1$outboundSchema.parse(
      getUnproxiedMcpServerSecurityOption1,
    ),
  );
}

/** @internal */
export type GetUnproxiedMcpServerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetUnproxiedMcpServerSecurityOption2$outboundSchema: z.ZodMiniType<
  GetUnproxiedMcpServerSecurityOption2$Outbound,
  GetUnproxiedMcpServerSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getUnproxiedMcpServerSecurityOption2ToJSON(
  getUnproxiedMcpServerSecurityOption2: GetUnproxiedMcpServerSecurityOption2,
): string {
  return JSON.stringify(
    GetUnproxiedMcpServerSecurityOption2$outboundSchema.parse(
      getUnproxiedMcpServerSecurityOption2,
    ),
  );
}

/** @internal */
export type GetUnproxiedMcpServerSecurity$Outbound = {
  Option1?: GetUnproxiedMcpServerSecurityOption1$Outbound | undefined;
  Option2?: GetUnproxiedMcpServerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetUnproxiedMcpServerSecurity$outboundSchema: z.ZodMiniType<
  GetUnproxiedMcpServerSecurity$Outbound,
  GetUnproxiedMcpServerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetUnproxiedMcpServerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetUnproxiedMcpServerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getUnproxiedMcpServerSecurityToJSON(
  getUnproxiedMcpServerSecurity: GetUnproxiedMcpServerSecurity,
): string {
  return JSON.stringify(
    GetUnproxiedMcpServerSecurity$outboundSchema.parse(
      getUnproxiedMcpServerSecurity,
    ),
  );
}

/** @internal */
export type GetUnproxiedMcpServerRequest$Outbound = {
  id?: string | undefined;
  slug?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetUnproxiedMcpServerRequest$outboundSchema: z.ZodMiniType<
  GetUnproxiedMcpServerRequest$Outbound,
  GetUnproxiedMcpServerRequest
> = z.pipe(
  z.object({
    id: z.optional(z.string()),
    slug: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function getUnproxiedMcpServerRequestToJSON(
  getUnproxiedMcpServerRequest: GetUnproxiedMcpServerRequest,
): string {
  return JSON.stringify(
    GetUnproxiedMcpServerRequest$outboundSchema.parse(
      getUnproxiedMcpServerRequest,
    ),
  );
}
